import { useEffect, useState } from 'react';
import { INITIAL_FILTERS } from 'src/store/filters/filtersStore';
import {
  useFilterSettingsStore,
  useLabels,
  useProjectsOverviewStore,
  useProjectRequestCountStore,
} from 'src/StoreDataProvider';

const ProjectCount: () => JSX.Element = () => {
  const { numberOfItems } = useProjectsOverviewStore();
  const { projectRequestCount } = useProjectRequestCountStore();
  const labels = useLabels();
  const filterSettings = useFilterSettingsStore();
  const [ariaStatusContent, setAriaStatusContent] = useState('');

  const getFiltersChanged = (): boolean => {
    const tempFilterSettings = { ...filterSettings };
    tempFilterSettings.page = INITIAL_FILTERS.page;
    tempFilterSettings.sort = INITIAL_FILTERS.sort;
    tempFilterSettings.size = INITIAL_FILTERS.size;
    return (
      JSON.stringify(tempFilterSettings) !== JSON.stringify(INITIAL_FILTERS)
    );
  };

  useEffect(() => {
    if (projectRequestCount > 0) {
      if (!getFiltersChanged()) {
        setAriaStatusContent(`${numberOfItems} ${labels.projects}`);
      } else {
        setAriaStatusContent(
          `${labels.projectSearchInfo1} ${numberOfItems} ${
            numberOfItems > 1
              ? labels.projectSearchInfo2
              : labels.projectSearchInfo2Singular
          }`
        );
      }
    }
  }, [projectRequestCount]);

  return (
    <>
      <div id="entry-count-info" className="entry-count-info">
        {!getFiltersChanged() ? (
          <>
            <div className="entry-count-info__number">{numberOfItems}</div>
            {labels.projects}
          </>
        ) : (
          <>
            <div className="entry-count-info__first">
              {labels.projectSearchInfo1}
            </div>
            <div className="entry-count-info__number">{numberOfItems}</div>
            {numberOfItems > 1
              ? labels.projectSearchInfo2
              : labels.projectSearchInfo2Singular}
          </>
        )}
      </div>
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-relevant="all"
        className="offscreen"
      >
        {ariaStatusContent}
      </div>
      <hr aria-hidden="true" />
    </>
  );
};

export default ProjectCount;
